module.exports = __webpack_public_path__ + "img/geo-zones.d4617ac8.svg";